/**
 * Animation + interaction timing constants (R1.L2).
 *
 * Centralizes magic timer values that were scattered across view files.
 * Keeping them in one place makes density-mode tuning (compact vs.
 * comfortable) and a future `prefers-reduced-motion` pass mechanical:
 * read these once, scale or zero them, never hunt down setTimeout sites.
 */

/** Storyboard scrubber auto-advance — slower (story pace). */
export const STORYBOARD_PLAY_MS = 800;

/** Drift timeline scrubber auto-advance — medium pace. */
export const DRIFT_PLAY_MS = 700;

/** Simulation/sandbox scrubber auto-advance — quicker (demo pace). */
export const SIMULATION_PLAY_MS = 600;

/** Copy-to-clipboard "Copied!" feedback duration. */
export const COPY_FEEDBACK_MS = 2000;
